import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { LeadForm } from "./LeadForm";
import { useLead } from "../context/LeadContext";

export const LeadDialog = () => {
  const { open, setOpen, defaults } = useLead();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="card-dark border-gold/30 max-w-lg max-h-[92vh] overflow-y-auto"
        data-testid="lead-dialog"
      >
        <DialogHeader>
          <div className="inline-block text-xs uppercase tracking-[0.2em] font-bold text-gold mb-1">
            Apply Now
          </div>
          <DialogTitle className="font-heading text-2xl font-extrabold text-white">
            Get Your <span className="gold-text">Loan Approved</span>
          </DialogTitle>
          <p className="text-slate-400 text-sm">
            Low CIBIL, NPA or rejected before? We specialise in tough cases. Fill in the form and our expert will call you.
          </p>
        </DialogHeader>
        <div className="mt-2">
          <LeadForm defaults={defaults} onSuccess={() => setTimeout(() => setOpen(false), 2500)} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
